import { Trans } from "@lingui/react";
import { Icon } from "../Icon.tsx";

export const ImageMissing = () => {
  return (
    <div
      className="flex flex-col w-full h-full justify-center items-center object-contain s-bg-subtle"
      style={{ aspectRatio: "4/3" }}
    >
      <Icon name="Image" size="56px" />
      <p>
        <Trans id="imageGallery.imageMissing" message="Image missing" />
      </p>
    </div>
  );
};
